module.exports = __webpack_public_path__ + "static/media/SpotfyActive@3x.42e236a5.png";